import { useEffect, useState } from "react";
import { TrendingUp, Activity } from "lucide-react";
import { api } from "../../lib/api";
import { useLiveMarket } from "../../context/LiveMarketContext";

const symbol = (p) => {
  const map = { "Google Sheets": "GSHT", PowerPoint: "PPTX" };
  return (map[p.software_type] || p.software_type.slice(0, 4)).toUpperCase();
};

export const MoversStrip = ({ onSelect }) => {
  const [movers, setMovers] = useState([]);
  const { prices } = useLiveMarket();

  useEffect(() => {
    api.products({ sort: "savings" }).then((list) => setMovers(list.slice(0, 8))).catch(() => {});
  }, []);

  if (!movers.length) return null;

  return (
    <section data-testid="movers-strip" className="border-b border-white/10 bg-slate-950">
      <div className="mx-auto flex max-w-[1400px] items-stretch px-0">
        <div className="hidden flex-shrink-0 items-center gap-2 border-r border-emerald-500/20 px-5 sm:flex">
          <Activity className="h-4 w-4 text-emerald-400" />
          <span className="font-mono text-xs font-bold uppercase tracking-widest text-emerald-400">Top Movers</span>
        </div>
        <div className="flex flex-1 gap-0 overflow-x-auto">
          {movers.map((p) => {
            const disc = prices[p.id]?.discount_pct ?? p.pricing?.discount_pct ?? 0;
            return (
              <button
                key={p.id}
                data-testid={`mover-${p.id}`}
                onClick={() => onSelect && onSelect(p)}
                className="group flex flex-shrink-0 items-center gap-3 border-r border-white/10 px-5 py-3 text-left transition-colors duration-200 hover:bg-emerald-500/5"
              >
                <span className="font-mono text-xs font-bold tracking-wider text-white">{symbol(p)}</span>
                <span className="max-w-[120px] truncate font-mono text-[11px] text-slate-500 group-hover:text-slate-300">{p.title}</span>
                <span className="flex items-center gap-0.5 font-mono text-xs font-bold text-emerald-400">
                  <TrendingUp className="h-3 w-3" /> +{disc}%
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MoversStrip;
